import { mapKeys } from 'lodash-es'

export const HTML_MANUAL = 'HTML_MANUAL'
export const HTML_AUTOMATIC = 'HTML_AUTOMATIC'
export const HTML_TEMPLATE = 'HTML_TEMPLATE'
export const DOCUMENT_PDF = 'DOCUMENT_PDF'
export const DOCUMENT_IMAGE = 'DOCUMENT_IMAGE'
export const GOOGLE_MENU_ITEMS = 'GOOGLE_MENU_ITEMS'

export const MENU_SCRAPING_TYPES = mapKeys(
  [
    { name: 'HTML Manual', value: HTML_MANUAL },
    { name: 'HTML Automatic', value: HTML_AUTOMATIC },
    { name: 'HTML Template', value: HTML_TEMPLATE },
    { name: 'Document PDF', value: DOCUMENT_PDF },
    { name: 'Document Image', value: DOCUMENT_IMAGE },
    { name: 'Google Menu Items', value: GOOGLE_MENU_ITEMS },
  ],
  'value',
)
